/**
 * @author PoornaChandu
 * @description 
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import AllGraphView from './AllGraphView';
const AllGraphComponent = (props) => {
  const [AllFilterData, setAllFilterData] = useState(props.AllFilterData || []);
  const [OperatorList, setOperatorList] = useState([]);
  const [filterData, setFilterData] = useState(props.FilterData || []);
  const [codeType,setCodeType] = useState(props.CodeType || 'Device');
  // const [ObservationList, setObservationList] = useState([]);
  useEffect(() => {
    if (props.AllFilterData !== AllFilterData) {
      setAllFilterData(props.AllFilterData);
    }
    if (props.OperatorList !== OperatorList) {
      setOperatorList(props.OperatorList);
    }
    if (codeType !== props.CodeType) {
      setCodeType(props.CodeType);
    }
    if (filterData !== props.FilterData) {
      setFilterData(props.FilterData);
    }
  }, [props.AllFilterData, props.OperatorList ,props.CodeType ,props.FilterData]);
  const handleObservationList = (observationList) => {
    // setObservationList(observationList);
    props.ObservationList(observationList);
  };
  return (
    <div style={{}}>
      {AllFilterData &&
        Array.isArray(AllFilterData) &&
        AllFilterData.map((filter, index) => {
          return (
            <div style={{ marginTop: '25px', height: '400px' }} key={index}>
              {/* <div style={{ margin: '5px 0px', display: 'flex', justifyContent: 'flex-end' }}>
                {constant &&
                  Array.isArray(constant.operatorList) &&
                  constant.operatorList &&
                  constant.operatorList.map((operator, index) => {
                    return <Checkbox key={index}>{operator}</Checkbox>;
                  })}
              </div> */}
              <AllGraphView
                payload={filter}
                OperatorList={OperatorList}
                ObservationList={handleObservationList}
                CodeType={codeType}
                selectedName={props.FilterData}
              />
            </div>
          );
        })}
    </div>
  );
};
const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone
});
export default connect(mapStateToProps)(AllGraphComponent);